var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{class:[
    'el-button',
    this.type ? 'el-button--'+this.type : 'el-button--default',
    ( _obj = {}, _obj['el-button--'+this.size] = this.size, _obj['is-plain'] =  this.plain == '', _obj['is-circle'] =  this.circle == '', _obj['is-round'] =  this.round == '', _obj )],attrs:{"to":_vm.to? _vm.to:'/',"target":_vm.target}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }